module.exports = __webpack_public_path__ + "img/lobby_function_bg.4d8ca069.png";